import { useEffect } from 'react';

interface JsonLdProps {
  id: string;
  data: object;
}

export default function JsonLd({ id, data }: JsonLdProps) {
  useEffect(() => {
    const old = document.getElementById(id);
    if (old) old.remove();
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = id;
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
    return () => {
      s.remove();
    };
  }, [id, data]);

  return null;
}